import React, { useEffect, useState } from 'react'
import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import HeaderPage from '../../components/HeaderPage';
import LoadingScreen from '../../components/LoadingScreen';

const AccountRefer = () => {


  const { IsUserData } = useBlogContext();


  const [referralCode, setReferralCode] = useState(null); // 'all', 'today', '7days', '1month'

  const [Refer, setRefer] = useState([]); // 'all', 'today', '7days', '1month'


  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode);
    toast.success("Referral code copied to clipboard!");
  };


  useEffect(() => {
    if (IsUserData) {
      if (IsUserData.code) {
        setReferralCode(IsUserData.code);
        setRefer(IsUserData.refer ?? [])
      }
    }
  }, [IsUserData]);


  return (
    <>

      <HeaderPage title={'Refer & Earn'} />

      <main className="page-content bg-light pb-5" style={{ minHeight: "100vh" }}>
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="w-100">
              {IsUserData.code ?
                <>

                  <div className="card shadow border-0 rounded-4">
                    <div className="card-body text-center p-5">
                      <div className="mb-4">
                        <span className='h1 m-0' style={{ fontSize: 80 }}> 🎉 </span>

                      </div>
                      <h3 className="fw-bold mb-3 text-dark">Invite Your Friends </h3>
                      <p className="text-muted mb-4">
                        Share your unique referral code with friends and earn rewards when they join!
                      </p>

                      <div className="input-group mb-4 shadow-sm rounded">
                        <input
                          type="text"
                          className="form-control text-center fw-semibold"
                          value={referralCode}
                          readOnly
                          style={{ fontSize: "1.1rem" }}
                        />
                        <button
                          className="btn btn-primary fw-semibold"
                          onClick={handleCopy}
                          type="button"
                        >
                          <i className="bi bi-clipboard me-1"></i> Copy
                        </button>
                      </div>

                      <hr className="my-4" />

                      <p className="text-primary small mb-0">
                        Your and your friend got rewards just copy paste this code while signup
                      </p>



                    </div>
                  </div>
                  {Refer?.length > 0 && (
                    <>
                      <h4>Referral List</h4>
                      <table className="table table-bordered table-striped table-hover">
                        <thead className="table-dark">
                          <tr>
                            <th>#</th>
                            <th>Username</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Refer?.length > 0 ? (
                            Refer.map((item, index) => (
                              <tr key={item._id}>
                                <td>{index + 1}</td>
                                <td>{item.username}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2" className="text-center">
                                No referrals found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                    </>)}



                </>
                :
                <LoadingScreen />}

            </div>
          </div>
        </div>
      </main >

    </>
  )
}

export default AccountRefer